import styled from 'styled-components';

export const BackgroundBtn = styled.div`
  background-color: #784f33;
`;
